import type { Event } from '@/types/event';
import { SourceType } from '@/types/source';

// Scene events are stored as report custom events, which the backend only
// supports for file sources and which require the scene time window.
export function canAddEventToReport(event: Event): boolean {
    return (
        event.type !== 'SCENE' ||
        (event.sourceType === SourceType.FILE &&
            event.startTime !== undefined &&
            event.endTime !== undefined)
    );
}
